import { DispatchType } from '../../../@types/redux-types'
import { tracking } from '../../../tracking/tracking'
import { InitState } from '../../reducers/root/initialState'
import { AddressFeatureState, FlowState, MultimediaState } from '../../../@types/state-types'
import { realEstateToApi } from '../../../api/realEstate/converters/toApi/realEstateToApi'
import { getPreview } from '../../../api/preview/previewApi'
import { setPreviewData, showPreviewModal } from '../../reducers/preview/previewFeature'
import { ContentStateInterface } from '../../../@types/types'
import { getDefaultLogger } from '../../../services/logger/logger'

export const doPreview = (newInsertionData: ContentStateInterface) => {
  return async (dispatch: DispatchType, getState: () => InitState) => {
    dispatch(showPreviewModal())

    const addressFeature: AddressFeatureState = getState().addressFeature
    const insertionData = newInsertionData
    const insertionIdentification = getState().insertionFeature.insertionIdentification
    const multiMediaFeature: MultimediaState = getState().multimediaFeature
    const flowFeature: FlowState = getState().flowFeature
    const realEstateDTO = realEstateToApi(
      insertionIdentification,
      insertionData,
      multiMediaFeature,
      flowFeature,
      addressFeature
    )

    tracking({
      flowInformation: getState().flowFeature.flowInformation,
      eventName: 'preview_complete_button_click',
      entryMode: getState().insertionFeature.insertionIdentification.metaInformation?.entryMode,
    })

    await getPreview(realEstateDTO)
      .then((data) => dispatch(setPreviewData({ previewData: data })))
      .catch((reason) => {
        getDefaultLogger().warn('Failed show preview', reason)
        dispatch(setPreviewData({ previewData: undefined }))
      })
  }
}
